import { defineComponent as _defineComponent } from 'vue'
import {useModalInstance} from '@/composables/useModalInstance';
import {HardConfirmModalData} from '@/components/fpComponents/services/ModalService/hardConfirmModal/index';
import {ref} from 'vue';
import EnvironmentService from '@/env/EnvironmentService';


export default /*#__PURE__*/_defineComponent({
  __name: 'HardConfirmModal',
  setup(__props) {

const appDomainConfig = EnvironmentService.Environment.getAppDomainConfig();
const validationKey: string = appDomainConfig.name.split('.')[0].toUpperCase();
const userInputKey = ref<string>('');
const modal = useModalInstance<HardConfirmModalData, boolean>();

return { __sfc: true,appDomainConfig, validationKey, userInputKey, modal }
}

})